
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[[...params]]",
      function () {
        return require("private-next-pages/shop/[[...params]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[[...params]]"])
      });
    }
  